<script>
/**
 * SubForm | Sample
 * 
 * Permite la edición parcial de componentes de formulario en contexto 
 * aside para automodal.vue, solo requiere que se pase en v-model el "form" completo.
 * 
 * P. e:
 * <sub-form-inputs v-model="form" />
 * 
 * Está establecido en workingValue: {} los componentes que modificará directamente éste
 * componente en form. 
 * 
 * El resto se traerá de manera automática.
 * 
 * #bug
 * Hay un error conocido en fechas, puede haber en otros tipos
 * de datos diferentes.
 * 
 * @author Daniel Lepe
 * @version 1.0
 * @date 7/jan/2023
 */
import _ from 'lodash';
import {getTimeSelectors} from './time-selectors'
import imgInputAutoload from '../../elements/img-input-autoload.vue';
export default {
	components: { imgInputAutoload },
    name: 'CookingInputs',
    props: {
        value: {
            type: Object
        }
    },
    data: () => {
        return {
            duraciones: {
                duracion_preparacion_min: 'Preparacion',
                duracion_coccion_min: 'Cocción',
                // duracion_abatimiento_min: 'Abatimiento',
            },
            workingValue: {
                imagen: null,
                // ANY FIELD HERE REQUIRE HIS HOMOLOGATION IN WATCHER
                duracion_preparacion_min: null,
                duracion_coccion_min: null,
                // duracion_abatimiento_min: null
            }
        }
    },
    watch: {
        'workingValue.imagen'(){
            this.$emit('input', this.mergedValue)
        },
        'value.imagen'(){
            this.localHomolage('imagen')
        },
        'value.duracion_preparacion_min'(){
            this.localHomolage('duracion_preparacion_min')
        },
        'value.duracion_coccion_min'(){
            this.localHomolage('duracion_coccion_min')
        },
        'value.duracion_abatimiento_min'(){
            this.localHomolage('duracion_abatimiento_min')
        }
    },
    computed: {
        mergedValue(){
            let merged = _.cloneDeep(this.value);
            _.forEach(this.workingValue, (itemVal, item) => {
                merged[item] = _.clone(itemVal);
            })
            return merged;
        }
    },
    beforeMount() {
        _.forEach(this.workingValue, (itemValue, item) => {
            this.workingValue[item] = _.clone(this.value[item])
        })
    },
    methods: {
        getTimeSelectors,
        localHomolage(item){
            if(this.workingValue[item] != this.value[item])
                this.workingValue[item] = _.clone(this.value[item])
        }
    }
}
</script>

<template>
    <div id="CookingInputs">
        <div class="ui-input-handler">

            <storage-img-uploader class="mb-4" v-model="workingValue.imagen" label="false"/>

            <hr>

            <!-- DURACIONES -->
            <b-row>
                <b-col v-for="(lab, input) in duraciones" :key="input">
                    <b-form-group :label="lab" :label-for="input">
                        <b-form-select :id="input"  v-model="workingValue[input]" 
                            :options="getTimeSelectors()"
                            @change="$emit('input', mergedValue)"/>
                    </b-form-group>
                </b-col>
            </b-row>

        </div>
    </div>
</template>